var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 500,
    viewBox: "22 11.7 18.5 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8323_10753",
    x1: 34.5132,
    y1: 15.5354,
    x2: 27.1574,
    y2: 30.4484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3296,
    stopColor: "#3F8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#3E9638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9341,
    stopColor: "#3DA92E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DAE2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8323_10753",
    x1: 30.0088,
    y1: 23.3589,
    x2: 50.5328,
    y2: 8.28841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#3F873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#52A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7129,
    stopColor: "#64B749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6ABF4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8323_10753",
    x1: 21.9168,
    y1: 22.2608,
    x2: 40.5549,
    y2: 22.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6ABF4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#64B749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5984,
    stopColor: "#52A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#3F873F"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7207 12.0513C31.4145 11.8781 31.051 11.8781 30.7449 12.0513L22.6902 16.7294C22.3841 16.9027 22.2119 17.2299 22.2119 17.5765V26.9518C22.2119 27.2984 22.4032 27.6256 22.6902 27.7989L30.7449 32.477C31.051 32.6502 31.4145 32.6502 31.7207 32.477L39.7753 27.7989C40.0815 27.6256 40.2536 27.2984 40.2536 26.9518V17.5765C40.2536 17.2299 40.0623 16.9027 39.7753 16.7294L31.7207 12.0513Z",
    fill: "url(#paint0_linear_8323_10753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7946 16.7294L31.7017 12.0513C31.6252 12.0128 31.5295 11.9743 31.453 11.9551L22.3843 27.5679C22.4608 27.6641 22.5565 27.7411 22.6521 27.7989L30.7451 32.477C30.9747 32.6117 31.2425 32.6502 31.4912 32.5732L40.0051 16.9027C39.9477 16.8257 39.8712 16.7679 39.7946 16.7294Z",
    fill: "url(#paint1_linear_8323_10753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7947 27.7986C40.0243 27.6638 40.1965 27.4328 40.273 27.1825L31.4147 11.9355C31.1852 11.897 30.9364 11.9162 30.726 12.051L22.6904 16.7098L31.3573 32.6114C31.4721 32.5921 31.6061 32.5536 31.7209 32.4959L39.7947 27.7986Z",
    fill: "url(#paint2_linear_8323_10753)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.9f59d0507bdb41b29478e7219e6cd228.svg";
export { ForwardRef as ReactComponent };